"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Car, Sparkles, User, PartyPopper } from "lucide-react";
export default function ServiceDetails() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    id: 1,
    title: "Luxury Black Car Chauffeur Service",
    description: "Experience the epitome of elegance with our premium sedan service, perfect for business executives and discerning travelers seeking sophistication and comfort.",
    icon: Car,
    bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_black_sedan_la.webp",
    delay: "0ms"
  }, {
    id: 2,
    title: "SUV Chauffeur Service",
    description: "Spacious and refined, our luxury SUVs provide ample room and VIP comfort for group travel, family journeys, or those who prefer extra space without compromising style.",
    icon: Sparkles,
    bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/premium_suv_interior_luxury.png",
    delay: "100ms"
  }, {
    id: 3,
    title: "Airport Transfers",
    description: "Punctual, reliable, and stress-free airport pickups and drop-offs. Our professional chauffeurs monitor flight schedules to ensure seamless arrivals and departures.",
    icon: User,
    bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/lax_airport_chauffeur_transfer.png",
    delay: "200ms"
  }, {
    id: 4,
    title: "Hourly & Event Bookings",
    description: "From corporate functions to gala events, our flexible hourly service provides discreet, premium transportation tailored to your schedule and special occasions.",
    icon: PartyPopper,
    bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_event_transportation_la.png",
    delay: "300ms"
  }];
  const refs = [ref1, ref2, ref3, ref4];
  const visibilities = [isVisible1, isVisible2, isVisible3, isVisible4];
  return <section id="service-details" className="bg-background-light text-foreground py-32 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-6 tracking-tight text-black">
            Our <span className="text-primary">Premium</span> Services
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto font-sans">
            Discover our comprehensive range of luxury chauffeur services, each designed to deliver
            exceptional comfort, punctuality, and discretion throughout Los Angeles and surrounding
            areas.
          </p>
        </div>

        <div className="grid gap-8 md:gap-12">
          {services.map((service, i) => {
          const Icon = service.icon;
          const ref = refs[i];
          const isVisible = visibilities[i];
          return <div key={service.id} data-index={i} ref={ref} className="transition-all duration-700 ease-out" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transitionDelay: service.delay
          }}>
                <Card className="relative overflow-hidden glass-effect border-[#333] group min-h-[450px] md:min-h-[500px] flex flex-col md:flex-row items-stretch p-0 rounded-lg shadow-medium hover:shadow-strong">
                  {}
                  <div className="relative w-full md:w-1/2 overflow-hidden">
                    <img src={service.bgImage} data-wvc-srcset={`${service.bgImage}-wvc-srcset`} data-wvc-sizes={`${service.bgImage}-wvc-sizes`} alt={service.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                    <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300" />
                  </div>

                  {}
                  <CardContent className="relative z-10 flex flex-col justify-center p-8 md:p-12 md:w-1/2 bg-background-dark text-white">
                    <div className="mb-6">
                      <div className="inline-flex items-center justify-center w-14 h-14 rounded-lg bg-primary/10 border border-[#333] mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                        <Icon className="w-7 h-7 text-primary" />
                      </div>
                      
                      <h3 className="text-2xl md:text-3xl font-heading font-bold mb-4 text-white tracking-tight">
                        {service.title}
                      </h3>

                      <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-8 font-sans">
                        {service.description}
                      </p>
                    </div>

                    <div className="mt-auto">
                      <Link to="/ReservationsPage" className="inline-flex items-center justify-center rounded text-[#1A1A1A] px-8 py-4 font-semibold text-sm uppercase tracking-wider transition-all duration-80 backdrop-blur-md bg-[#C5A059] hover:bg-[#B8935A] hover:shadow-medium hover:scale-[1.02] active:scale-100 gap-3" style={{
                    backgroundColor: 'rgba(197, 160, 89, 0.8)',
                    backdropFilter: 'blur(12px)'
                  }}>
                        Book This Service
                        <svg className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}